<!-- Caption -->
<h1 mat-dialog-title class="mb-1">{{ oData.title }}</h1>

<!-- Body -->
<div mat-dialog-content class="d-flex align-items-center">
    <img class="icon mr-3" [src]="iconMap[oData.type] || iconMap[1]" alt="" />
    <span>{{ oData.msg }}</span>
</div>

<!-- Actions -->
<div mat-dialog-actions class="d-flex justify-content-end mb-3 mr-4 p-0">
    <button class="btn" [ngClass]="btnClassMap[oData.type] || 'btn-secondary'" (click)="closeAlert()">
        {{ oData.closeBtn }}
    </button>
</div>
